export const SAGA_GET_NIVEL = "nivelesReducer/SAGA_GET_NIVEL";
export const SAGA_GET_NIVELES = "nivelesReducer/SAGA_GET_NIVELES";
export const SET_NIVELES = "nivelesReducer/SET_NIVELES";
export const SAVE_NIVEL = "nivelesReducer/SAVE_NIVEL";
export const SAGA_ELIMINAR_NIVEL = "nivelesReducer/SAGA_ELIMINAR_NIVEL";
export const SAGA_GET_NIVEL_BY_CODIGO = "nivelesReducer/SAGA_GET_NIVEL_BY_CODIGO";
export const SAGA_GET_NIVEL_BY_NOMBRE = "nivelesReducer/SAGA_GET_NIVEL_BY_NOMBRE";
export const SAGA_SAVE_NIVEL = "nivelesReducer/SAGA_SAVE_NIVEL";

export const sagaGetNivel = (idNivel) => ({
  type: SAGA_GET_NIVEL,
  payload: { idNivel },
});

export const sagaGetNiveles = (descripcion) => ({
  type: SAGA_GET_NIVELES,
  query: descripcion,
});

export const setNiveles = (payload) => ({
  type: SET_NIVELES,
  payload,
});

export const saveNivel = (payload) => ({
  type: SAVE_NIVEL,
  payload,
});

export const sagaEliminarNivel = (idNivel) => ({
  type: SAGA_ELIMINAR_NIVEL,
  payload: { idNivel },
});

export const sagaGetNivelByCodigo = (codigo) => ({
  type: SAGA_GET_NIVEL_BY_CODIGO,
  payload: { codigo },
});

export const sagaGetNivelByNombre = (descripcion) => ({
  type: SAGA_GET_NIVEL_BY_NOMBRE,
  payload: { descripcion },
});

export const sagaSaveNivel = (payload) => ({
  type: SAGA_SAVE_NIVEL,
  payload,
});
